import React from "react";
import { Add, SaveOutlined } from "@mui/icons-material"
import { Alert, Box, Container, Divider, IconButton, List, ListItem, ListItemText, Modal, Paper, Snackbar, Stack, TextField, Tooltip, Typography } from "@mui/material"
import EscolheUserPopover from "../../../user/EscolheUserPopover";
import Service from "../../../../../util/Service";


export default function Notificacao() {
    return (
        <Container maxWidth="sm">
            <FormNotificacao />
        </Container>
    )
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // mb:10,
    p: "5px",
  };
const stBtn = {
    position: 'relative',
    float: 'right'
}
function FormNotificacao() {
    const [openAddAction, setOpenAddAction] = React.useState(false);
    const [nmAction, setNmAction] = React.useState('');
    const [action, setAction] = React.useState('');
    const [actions, setActions]= React.useState([]);
    const [lstUser, setLstUser]= React.useState([]);
    const [users, setUsers] = React.useState([]);
    const [txtUser, setTxtUser]= React.useState('');
    const [type, setType]= React.useState('');
    const [titulo, setTitulo]= React.useState('');
    const [icone, setIcone]= React.useState('');
    const [msg, setMsg]= React.useState('');
    const [erro, setErro]= React.useState({
        open: false,
        msg:"",
        severity: "error"
    });

    React.useEffect(() => {
        buscaUsers();
    }, []);

    React.useEffect(() => {
        let txt = '';
        if( lstUser && lstUser.length > 0){
            for(let u of lstUser){
                txt+=u.nome+"; ";
            }
            txt = txt.substring(0, txt.length-1);
        }
        setTxtUser(txt);
    }, [lstUser]);

    function buscaUsers() {
        Service.GET('/api/security/user/findAll').then(r => {
            setUsers(r);
        });
    }
    function handleCloseSnack(){
        setErro({
            open: false,
            msg:"",
            severity: "error"
        });
    }
    function handleIncluirAction(){
        const arr = [...actions];
        arr.push({
            nome: nmAction,
            action: action
        })
        setActions(arr);
        setOpenAddAction(false);
    }
    function handleMembroToAdd(dado){
        const arr = [...lstUser];
        arr.push({
            nome: dado.login,
            email: dado.email
        });
        setLstUser( arr );
    }
    function handleSalvar(){
        const dado = {
            titulo: titulo,
            type: type,
            desc: msg,
            icone: icone,
            users: lstUser,
            actions: actions
        }
        if( !lstUser || lstUser.length === 0){
            setErro({
                open: true,
                msg:"Necessário informar que será notificado",
                severity: "error"
            })
            return;
        }
        if( !dado.titulo || dado.titulo.length === 0){
            setErro({
                open: true,
                msg:"Titulo é obrigatório!",
                severity: "error"
            })
            return;
        }
        
        Service.POST('/api/security/not/add', dado).then( r=>{        
            if( r.success){
                setErro({
                    open: true,
                    severity: 'success',
                    msg: "Quantidade de notificação enviada: "+r.qtd
                })
            }
        })
    }
    return (
        <Paper sx={{p:1, m: 2}}>
            <IconButton color="primary" aria-label="Incluir Notificação" style={stBtn} onClick={handleSalvar}>
                <SaveOutlined />
            </IconButton>
        <Stack spacing={1}>

            <Stack direction="row" spacing={2}>
                <TextField id="users" label="Será notificado" variant="outlined" size="small" value={txtUser} fullWidth/>
                <EscolheUserPopover 
                    // membros={projeto.membros} 
                    action={handleMembroToAdd} 
                    lst={users} 
                    temAcessoBasico={true}
                    titulo="Quem será notificado"
                />
            </Stack>
            <Stack direction="row" spacing={2}>
                <TextField fullWidth value={type} onChange={(e)=> setType(e.target.value)} id="type" label="Tipo" variant="standard" />
                <TextField fullWidth value={titulo} onChange={(e)=> setTitulo(e.target.value)} id="titulo" label="Titulo" variant="standard" />
            </Stack>
            <TextField id="icone" label="Icone" value={icone} onChange={(e)=>setIcone(e.target.value) } variant="standard" />
            <TextField
                id="desc"
                label="Mensagem"
                multiline
                rows={4}
                value={msg} onChange={(e)=> setMsg(e.target.value)}
                defaultValue="Default Value"
            />
            <Typography>Acões</Typography>
            <Paper>
            <Tooltip title="Adiciona Ações"> 
                <IconButton className="pd-buttom-dir" onClick={()=>setOpenAddAction(true)}>
                    <Add />
                </IconButton>
            </Tooltip>
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                    {actions && actions.map((row,i)=>(
                        <React.Fragment key={i}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                primary={row.nome}
                                secondary={
                                    <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ color: 'text.primary', display: 'inline' }}
                                    >
                                        Ação
                                    </Typography>
                                    {" — "+row.action}
                                    </React.Fragment>
                                }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </React.Fragment>
                    ))}
                    
                </List>
            </Paper>

            <Modal
                open={openAddAction}
                onClose={()=>setOpenAddAction(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div >
                        <Typography variant="h6" component="h2">
                            Incluir ação
                            <IconButton className="pd-float-dir" color="primary" 
                                onClick={handleIncluirAction}
                            >
                                <Add />
                            </IconButton>
                        </Typography>
                        
                    </div>
                <Stack>
                    <TextField id="nmAction" label="Nome" variant="standard" value={nmAction} onChange={(e)=> setNmAction(e.target.value)}/>
                    <TextField id="action" label="Ação" variant="standard" value={action} onChange={(e)=> setAction(e.target.value)} />
                </Stack>
                </Box>
            </Modal>
        </Stack>
        <Snackbar open={erro.open} autoHideDuration={6000} onClose={handleCloseSnack}>
            <Alert
                onClose={handleCloseSnack}
                severity={erro.severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {erro.msg}
            </Alert>
        </Snackbar>
        </Paper>
    )
}